import { DataBean } from "../DataBean";

export class RecalculateDepreciation extends DataBean {


    public async recalculateDepreciationValues(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_recalculateDepreciationValues_Number", [id]);
    }

 
}